/**
 * Uusi versio palvelimella, selain ajaa vanhaa (pääChatin toimeksianto, Tonin välittämä 7.10.2026 10.56).
 *
 * Mitattu 7.10.: protot tarjoili ceb0b46:n oikein — index.html `no-cache`, nippu hajautusnimellä ja `immutable`, ja nippu sisälsi
 * «Standardi»- ja «katkaistu lähteessä» -tekstit. Silti Tonin kuvassa niitä ei ollut: ennen vientiä avattu välilehti ajaa yhä
 * vanhaa JavaScriptiä, koska SPA ei lataa itseään uudelleen. Välimuistiotsakkeet eivät auta muistissa olevaan koodiin.
 *
 * Mekanismi: selain tietää oman nippunsa nimen (script-elementti). Kun välilehti palaa näkyviin ja viiden minuutin välein se
 * hakee index.html:n ohi välimuistin ja vertaa nippujen nimiä. Ero → ilmoitus ja «Lataa uudelleen». Sivua ei ladata itsestään,
 * koska lomake voi olla kesken. Kehitystilassa (vite, ei /assets/-nippua) mekanismi on pois.
 */
import { useEffect, useState } from "react";
import { t } from "./kieli";

const NIPPU = /\/assets\/index-[A-Za-z0-9_-]+\.js/;

function oma(): string | null {
  for (const s of document.querySelectorAll<HTMLScriptElement>("script[type=module][src]")) {
    const m = NIPPU.exec(s.getAttribute("src") ?? ""); if (m) return m[0];
  }
  return null;
}

async function palvelimen(): Promise<string | null> {
  const r = await fetch("/", { cache: "no-store", credentials: "same-origin" });
  if (!r.ok) return null;
  return NIPPU.exec(await r.text())?.[0] ?? null;
}

export function UusiVersio() {
  const [uusi, setUusi] = useState(false);
  useEffect(() => {
    let kesken = false;
    const tarkista = async () => {
      if (kesken || document.visibilityState !== "visible") return;
      const o = oma(); if (!o) return;
      kesken = true;
      try { const p = await palvelimen(); if (p && p !== o) setUusi(true); } catch { /* verkko poissa: ei väitettä */ } finally { kesken = false; }
    };
    const v = setInterval(() => void tarkista(), 5 * 60 * 1000);
    const nakyviin = () => void tarkista();
    document.addEventListener("visibilitychange", nakyviin);
    window.addEventListener("focus", nakyviin);
    return () => { clearInterval(v); document.removeEventListener("visibilitychange", nakyviin); window.removeEventListener("focus", nakyviin); };
  }, []);
  if (!uusi) return null;
  return (
    <div className="uusi-versio" role="status" data-uusi-versio="">
      <span><b>{t("muu.versio.paivitetty")}</b> {t("muu.versio.selite")}</span>
      <button className="nappi" onClick={() => window.location.reload()}>{t("muu.versio.lataa")}</button>
    </div>
  );
}
